import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoMedia from 'theme/promoMedia';

import ListingTileWithPopup from '../ListingTile/ListingTileWithPopup';

const Container = styled.ul`
    display: flex;
    flex-flow: row wrap;
    justify-content: ${(props) => (props.centered ? 'center' : null)};
    list-style-type: none;
    margin: 0 -6px 32px -6px;
    row-gap: 26px;
    padding: 0;

    & > li {
        width: 50%;
    }

    ${promoMedia.tablet744} {
        margin: 0 -16px 48px -16px;
        row-gap: 36px;
    }

    ${promoMedia.desktop1440} {
        margin: 0 -16px 64px -16px;
        row-gap: 48px;

        & > li {
            width: 25%;
        }
    }
`;
export const ListingTilesSection = (props) => {
    return (
        <Container centered={props.centered}>
            {Array.isArray(props.data) &&
                props.data
                    .filter((item) => item !== null)
                    .map((item) => {
                        return (
                            <li key={item.id}>
                                <ListingTileWithPopup
                                    img={item.img}
                                    subtitle={item.subtitle}
                                    description={item.description}
                                    title={item.title}
                                    linkText={item.linkText}
                                    linkUrl={item.linkUrl}
                                    loadingLazy={props.loadingLazy}
                                />
                            </li>
                        );
                    })}
        </Container>
    );
};

ListingTilesSection.propTypes = {
    centered: PropTypes.bool,
    data: PropTypes.array,
    loadingLazy: PropTypes.bool,
};
